export const isEmailValid = (email: string) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const toBoldFormat = (text: string, textToFormat: string): string => {
  text = text.replace(textToFormat, `<strong>${textToFormat}</strong>`);
  return text;
};
